import React from "react";
import { Runtime } from "./runtime";

export const App = () => (
  <Runtime />
);
